import { render, staticRenderFns } from "./FirmasPoderes.vue?vue&type=template&id=084c6c5c&scoped=true"
import script from "./FirmasPoderes.vue?vue&type=script&lang=js"
export * from "./FirmasPoderes.vue?vue&type=script&lang=js"
import style0 from "./FirmasPoderes.vue?vue&type=style&index=0&id=084c6c5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084c6c5c",
  null
  
)

export default component.exports